module.exports = __webpack_public_path__ + "img/game-level-complete-coffee.9b4929fa.png";